// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610132210/js/" + chunkId + "." + {"44":"7278115f","225":"ea56f0be","481":"2b02f750","486":"79b6c481","770":"af29c9a9"}[chunkId] + ".0.6770960360036731.chunk.js";
};